module.exports = __webpack_public_path__ + "img/sw-logo-sm.ee4f8ada.webp";